/* script */
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

/**
 * This component is used to show the list of given API.
 *
 * It's an abstract component whose extending components must define
 * the document getter method.
 *
 * @vue-data {String} currentTab the current active tab
 * @vue-data {Boolean} loading the loading status
 * @vue-data {Object} doc the API documentation JSON
 * @vue-data {Object} doc.info the API documentation info
 * @vue-data {Array} doc.schemes the API documentation schemes
 * @vue-data {Array} doc.tags the API documentation tags set
 * @vue-data {Object} doc.definitsion the API documentation definitions
 * @vue-data {String} baseUrl the API base URL(s)
 *
 * @category docs.components
 * @exports GenericAPI
 * @component
 */
const __vue_script__ = {
    name: 'GenericAPI',

    data() {
        return {
            currentComponent: 'tags',
            loading: true,
            error: null,
            redocOptions: {
                hideDownloadButton: false
            }
        };
    },

    computed: {
        /**
         * The API base URL(s)
         *
         * @returns {String} the set of base URLs
         */
        baseUrl() {
            return this.doc?.schemes.map((scheme) => `${scheme}://${this.doc?.host}${this.doc?.basePath}`).join(', ');
        },

        /**
         * @returns {String} the backstage URL
         */
        backstageUrl() {
            const path = this.$route.params.eid ? `/event/${this.$route.params.eid}` : '';
            return this.$utils.url.getBackstageURL(window.location.host, path);
        }
    },

    mounted() {
        this.init();
    },

    methods: {
        /**
         * (Re)Initialize the component
         */
        async init() {
            try {
                this.loading = true;
                this.error = null;
                this.doc = await this.getDocumentation();
            } catch (error) {
                console.error('[GenericAPI] Error while getting documentation:', error.message);
                const status = get(error, 'response.status');

                this.error = 'general.error_occurred';

                if (status === 403) {
                    window.location.href = '/';
                }
            } finally {
                this.loading = false;
                /* global Redoc */
                /* eslint no-undef: "error" */
                await Redoc.init(this.doc, this.redocOptions, document.getElementsByClassName('doc-container')[0]);
            }
        },

        /**
         * This method must be overwritten by the extending component
         * and should return a promise containing the API documentation
         * as specified on Open API contract.
         *
         * @throws {Error} every kind of network or functional errors
         *
         * @returns {Promise<Object>} the Open API documentation JSON
         *
         * @abstract
         */
        getDocumentation() {
            // Stub
            return Promise.resolve({});
        },

        /**
         * This method must be overwritten by the extending component
         * and should return a string representing the API documentation URL.
         *
         * @returns {String} the Open API documentation URL
         *
         * @abstract
         */
        getDocumentationUrl() {
            // Stub
            return '';
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "api-directory" }, [
    _vm.error
      ? _c("div", { staticClass: "alert alert-error" }, [
          _c("p", [_vm._v(_vm._s(_vm.$t(_vm.error)))]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "doc-container" }),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/docs/src/components/GenericAPI.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__